var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 16.1H14.7V17.5H13.3V16.1ZM13.3 10.5H14.7V14.7H13.3V10.5ZM14 7C10.129 7 7 10.15 7 14C7 15.8565 7.7375 17.637 9.05025 18.9497C9.70026 19.5998 10.4719 20.1154 11.3212 20.4672C12.1705 20.8189 13.0807 21 14 21C15.8565 21 17.637 20.2625 18.9497 18.9497C20.2625 17.637 21 15.8565 21 14C21 13.0807 20.8189 12.1705 20.4672 11.3212C20.1154 10.4719 19.5998 9.70026 18.9497 9.05025C18.2997 8.40024 17.5281 7.88463 16.6788 7.53284C15.8295 7.18106 14.9193 7 14 7ZM14 19.6C12.5148 19.6 11.0904 19.01 10.0402 17.9598C8.99 16.9096 8.4 15.4852 8.4 14C8.4 12.5148 8.99 11.0904 10.0402 10.0402C11.0904 8.99 12.5148 8.4 14 8.4C15.4852 8.4 16.9096 8.99 17.9598 10.0402C19.01 11.0904 19.6 12.5148 19.6 14C19.6 15.4852 19.01 16.9096 17.9598 17.9598C16.9096 19.01 15.4852 19.6 14 19.6Z",
    fill: "#0066F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimTransactions);
export default __webpack_public_path__ + "static/media/ClaimTransactions.cc4777cf00f3a7f39ff4e29464682a5c.svg";
export { ForwardRef as ReactComponent };